import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Define translations directly
const enTranslation = {
  contactPage: {
    workingHours: "Opening Hours",
          mondayToSunday: "Tuesday - Saturday",
    workingHoursTime: "18:30 - 21:30",
          workingHoursDescription: "We're open Tuesday - Saturday to serve you with the best traditional Portuguese cuisine on Meia Praia beach."
  }
};

const ptTranslation = {
  contactPage: {
    workingHours: "Horário de Funcionamento",
          mondayToSunday: "Terça - Sábado",
    workingHoursTime: "18:30 - 21:30",
          workingHoursDescription: "Estamos abertos de Terça-feira a Sábado para o servir com a melhor cozinha tradicional portuguesa na praia da Meia Praia."
  }
};

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      pt: {
        translation: ptTranslation
      }
    },
    lng: 'en', // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // React already escapes values
    }
  });

export default i18n; 